import React, { useEffect } from "react";
import styles from './Navbar.module.css';
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import { get_productos ,setSearchTerm, setSelectedProductId, setSearchField } from "../../../redux/actions/productos";
import CartDrawer from "../../cart/CartDrawer";
import NavbarSearch from "./NavbarSearch";
import UserMenu from "./UserMenu";
import { logout } from "../../../redux/actions/auth";

const Navbar = ({
  get_productos,
  productos,
  user,
  setSearchTerm,
  setSelectedProductId,
  searchField,
  setSearchField,
  logout
}) => {

  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [get_productos]);

  const pathsToShowSearch = ["/carroproductos", "/ListaProductos"];
  const shouldDisplaySearch = pathsToShowSearch.includes(location.pathname);

  return (
    <nav className={`navbar ${styles.root}`}>
      <section className="mt-0">
      </section>
      {shouldDisplaySearch && (
        <NavbarSearch
          productos={productos}
          searchField={searchField}
          setSearchTerm={setSearchTerm}
          setSelectedProductId={setSelectedProductId}
          setSearchField={setSearchField}
        />
      )}
      <section className={`${styles.info} mt-0`}>
        {!user && (
          <Link to="/">
            <span className="text-white mr-3">Iniciar sesión</span>
          </Link>
        )}
        <UserMenu user={user} logout={logout} />
        <CartDrawer/>
      </section>
    </nav>
  );
};

const mapStateToProps = (state) => ({
  user: state.Auth.user,
  productos: state.Productos.productos,
  searchField: state.Productos.searchField,
});
const mapDispatchToProps = {
  get_productos,
  setSearchTerm,
  setSelectedProductId,
  setSearchField,
  logout,
};
export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
